// After a deploy, tabs still running the old build request lazy chunks that no longer exist.
// Do a full page load of the target URL so the new index.html and chunks are picked up.
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;
const CHUNK_RELOAD_KEY = 'chunk-reload-at';

let reloading = false;

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_ERROR.test(message);
}

/**
 * True once a reload for a stale chunk has started. The router rethrows the navigation error after
 * its handler runs, so the error still reaches `ErrorHandler` and Sentry before the page unloads —
 * `beforeSend` uses this to drop it, since the reload is the fix.
 */
export function isReloadingForNewVersion(): boolean {
  return reloading;
}

export function reloadOnChunkLoadError(error: unknown, url: string): void {
  if (!isChunkLoadError(error)) {
    return;
  }
  try {
    const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) ?? 0);
    if (Date.now() - lastReload < 10_000) {
      return; // avoid a reload loop if the chunk is genuinely missing
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    // sessionStorage unavailable; reload anyway
  }
  reloading = true;
  location.assign(url);
}
